<!--
 * @Author: ldx
 * @Date: 2023-03-29 17:18:06
 * @LastEditors: ldx
 * @LastEditTime: 2023-03-29 17:19:54
 * @Description: 自定义iframe组件
-->
<template>
  <div class="page-container">
    <iframe class="iframe" :src="url" scrolling="auto" frameborder="0" />
  </div>
</template>
<script>
export default {
  props: {
    url: {
      type: String,
      require: true
    }
  },
  data() {
    return {}
  }
}
</script>
<style lang="scss" scoped>
.page-container {
  height: calc(100% - 4px);

  // height: 100%;
  .iframe {
    width: 100%;
    height: 100%;
  }
}
</style>
